import { Injectable } from "@angular/core";
import * as moment from "moment";

@Injectable({
  providedIn: "root",
})
export class DatesHelpers {
  convertTimeTo24(time24: string = "14:00:00"): string {
    // Parse the time string
    const time = moment(time24, "HH:mm:ss");

    // Format the time in 12-hour format with AM/PM
    const formattedTime = time.format("hh:mm A");
    return formattedTime;
  }
  formatDateToTextual(dateString: string): string {
    // input :"24/08/1998" format
    // return Samedi 28 novembre 2023 format
    const date = moment(dateString, "DD/MM/YYYY");
    const formattedDate = date.locale("fr").format("dddd DD MMMM YYYY");
    return formattedDate;
  }
  formatDateToTextual2(isoDateString: string): string {
    // input :"2024-05-13T13:11:11.000000Z"
    // return Samedi 28 novembre 2023 format
    const date = moment(isoDateString);
    return date.locale("fr").format("dddd D MMMM YYYY");
  }
  formatDateToTextual2WithTime(isoDateString: string): string {
    // Input: "2024-05-13T13:11:11.000000Z"
    // Output: "Samedi 28 novembre 2023 à 13:11"
    const date = moment(isoDateString).locale("fr");
    return date.format("dddd D MMMM YYYY à HH:mm");
  }

  compareCurrentDates(date: string): string {
    //10/05/2024 with current date
    if (this.inPrevDays(date)) {
      return "PREV_DAY";
    } else if (this.inSameDay(date)) {
      return "SAME_DAY";
    } else {
      return "SAME_DAY";
    }
  }
  inNextDays(date: string): boolean {
    //10/05/2024 with current date
    let selectedDateObj = moment(date, "DD/MM/YYYY");
    let currentDate = moment();

    if (selectedDateObj.isAfter(currentDate, "day")) {
      return true;
    } else {
      return false;
    }
  }
  inSameDay(date: string): boolean {
    //10/05/2024 with current date
    let selectedDateObj = moment(date, "DD/MM/YYYY");
    let currentDate = moment();
    if (selectedDateObj.isSame(currentDate, "day")) {
      return true;
    } else {
      return false;
    }
  }
  inPrevDays(date: string): boolean {
    //10/05/2024 with current date
    let selectedDateObj = moment(date, "DD/MM/YYYY");
    let currentDate = moment();
    if (selectedDateObj.isBefore(currentDate, "day")) {
      return true;
    } else {
      return false;
    }
  }

  transformToArray(dateString: string): {
    month: string;
    day: string;
    year: string;
  } {
    const date = moment(dateString);
    return {
      month: date.format("MMM"),
      day: date.format("DD"),
      year: date.format("YYYY"),
    };
  }

  formatDateToArray(dateString: string): string[] {
    let date = this.formatDateToTextual(dateString);
    return date.split(" ");
  }
  getFullMonthName(monthAbbreviation: string): string {
    moment.locale("fr");
    const monthNumber = moment().month(monthAbbreviation).month();
    const fullMonthName = moment().month(monthNumber).format("MMMM");
    return fullMonthName;
  }

  getMonthAbbreviation(monthNumber: number): string {
    const monthAbbreviation = moment().month(monthNumber).format("MMM");
    return monthAbbreviation;
  }
  convertTo24HourFormat(time12h: string, period: string): string {
    let [hours, minutes] = time12h.split(":").map(Number);

    if (hours === 12) {
      hours = period.toUpperCase() === "AM" ? 0 : 12;
    } else {
      hours += period.toUpperCase() === "PM" ? 12 : 0;
    }
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  }
  convertDateFormat(inputDate: string): string {
    const [day, month, year] = inputDate.split("/");
    const date = new Date(`${year}-${month}-${day}`);
    return date.toISOString().split("T")[0];
  }
  convertDateFormat2(inputDate: string): string {
    const formattedDate = moment(inputDate).format("DD/MM/YYYY");
    const [day, month, year] = formattedDate.split("/");
    const date = new Date(`${year}-${month}-${day}`);
    return date.toISOString().split("T")[0];
  }

  secondsToTimeString(seconds: number): string {
    // Calculate hours, minutes, and seconds
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    // Pad hours, minutes, and seconds with leading zeros if needed
    const hoursStr = String(hours).padStart(2, "0");
    const minutesStr = String(minutes).padStart(2, "0");
    const secondsStr = String(secs).padStart(2, "0");

    // Return the formatted time string
    return `${hoursStr}:${minutesStr}:${secondsStr}`;
  }

  timeStringToSeconds(timeString: string | number | null | undefined): number {
    // Input: "HH:MM:SS", "HH:MM", or a number (seconds)
    // Output: number of seconds
    // Handle null, undefined, or empty strings
    if (timeString === null || timeString === undefined) {
      return 0;
    }

    // If it's already a number, return it directly (it's already in seconds)
    if (typeof timeString === 'number') {
      return Math.max(0, Math.floor(timeString)); // Ensure non-negative integer
    }

    // If it's a string, check if it's a pure number (seconds)
    if (typeof timeString === 'string') {
      const trimmed = timeString.trim();
      if (trimmed === '') {
        return 0;
      }

      // Check if it's a pure number (represents seconds directly)
      const numericValue = Number(trimmed);
      if (!isNaN(numericValue) && !trimmed.includes(':')) {
        // It's a number string representing seconds
        return Math.max(0, Math.floor(numericValue));
      }

      // Otherwise, try to parse as time string format
      const parts = trimmed.split(':');
      
      // Handle different time string formats
      let hours: number, minutes: number, seconds: number;
      
      if (parts.length === 3) {
        // Format: "HH:MM:SS"
        [hours, minutes, seconds] = parts.map(Number);
      } else if (parts.length === 2) {
        // Format: "HH:MM" - default seconds to 0
        [hours, minutes] = parts.map(Number);
        seconds = 0;
      } else {
        // Invalid format - try to parse as number one more time
        const fallbackValue = Number(trimmed);
        if (!isNaN(fallbackValue)) {
          return Math.max(0, Math.floor(fallbackValue));
        }
        console.warn(`Invalid time format: "${timeString}". Expected HH:MM:SS, HH:MM, or a number. Returning 0.`);
        return 0;
      }
      
      // Validate that all parts are valid numbers
      if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
        console.warn(`Invalid time format: "${timeString}". Could not parse numbers. Returning 0.`);
        return 0;
      }
      
      // Validate ranges
      if (hours < 0 || minutes < 0 || minutes >= 60 || seconds < 0 || seconds >= 60) {
        console.warn(`Invalid time values in: "${timeString}". Returning 0.`);
        return 0;
      }
      
      // Convert to total seconds
      return (hours * 3600) + (minutes * 60) + seconds;
    }

    // Fallback for any other type
    return 0;
  }

  checkCurrentDateInRange(start: string | Date, end: string | Date) {
    const now = moment(); // Current date and time
    const startDate = moment(start); // Parse start date
    const endDate = moment(end); // Parse end date

    // Check if the dates are valid
    if (!startDate.isValid() || !endDate.isValid()) {
      throw new Error("Invalid date format");
    }

    // Check if now is between start and end dates
    return now.isBetween(startDate, endDate, null, "[]"); // '[]' includes the start and end dates
  }
  checkDateInRange(
    date: string | Date,
    start: string | Date,
    end: string | Date
  ) {
    const now = moment(); // Current date and time
    const startDate = moment(start); // Parse start date
    const endDate = moment(end); // Parse end date

    // Check if the dates are valid
    if (!startDate.isValid() || !endDate.isValid()) {
      throw new Error("Invalid date format");
    }

    // Check if now is between start and end dates
    return now.isBetween(startDate, endDate, null, "[]"); // '[]' includes the start and end dates
  }
}
